import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { CoursesService } from "../services/courses.service";

@Injectable()
export class AdminDataGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router) { }

    // Return false if the user is not logged in
    canActivate() {
      const adminData = this.auth.user;

      if (adminData) {
          return true;
      } else {
          this.router.navigate(['/admin/home']);
          return false;
      }
    }
}
